<template>
	<div>
		<div class="coreView">
			<div class="imgView ">
				<!-- <div v-html="i.html" v-if="i.name==sampleName" v-for="(i,index) in imageAry"></div> -->
				<div v-html="product_content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '../common/request.js'
	export default {
		data() {
			return {
				products: [],
				product_content : ""
				
			}
		},
		created() {
			// 获取商品
			// request.uniRequest('/product/getProductList')
			// 	.then(res => {
			// 		this.products = res.data
			// 		let product_arr = this.products.filter(item => {
			// 			return item._id == this.$route.query.id
			// 		})
			// 		this.product_content = product_arr[0].product_html
					

					
			// 	}).catch(e => {})
			this.getProductList()
			
		},
		methods: {
			async getProductList() {
				let res = await this.$Cloud.table(`lf_func_lefan_product`).get({ page: 0, pageSize: 1000 })
				
				console.log('获取商品列表====>>>>>>',res)
				
				const {code,data} = res
				if(code == 200) {
					this.news = data.filter(item=>item.is_check==2)
				}
			}
		}
	}
</script>

<style>
	.coreView {
		
		background-color: white;
		align-self: center;
		width: 100%;
		max-width: 1024px;
		/* height: 40.5rem; */
		position: relative;
		margin: 0 auto 6.0rem;
		/* margin-top: 6.0rem; */
	}
	.coreView .imgView {
		width: 100%;
		margin: 0 a;
		font-size: 0;
		/* height: 100%; */
	}
	.coreView .imgView img {
		width: 100%;
		/* height: 50.75rem; */
	}
</style>